<button
    class="ap-action-icon"
    type="button"
    (click)="onClick.emit(undefined)"
    [disabled]="isDisabled() ? isDisabled() : null"
    [attr.aria-label]="ariaLabel() ? ariaLabel() : null"
    [attr.aria-disabled]="isDisabled() ? isDisabled() : null"
    data-testid="button"
>
    <ng-content></ng-content>
</button>
